@switch(selected_view()){
    @case ('add'){
        @if (elements_options().clientSecret) {
            @if(!loading()){
                <div class="new-card-header">
                    <h3 class="font-semibold">Add a Payment Method</h3>
                    @if(payment_methods().length){
                        <button mat-icon-button paint="dark" class="mat-elevation-z0" (click)="selected_view.set('list')" type="button"><mat-icon>list</mat-icon></button>
                    }
                </div>
            }
            <ngx-stripe-elements [stripe]="api.stripe" [elementsOptions]="elements_options()">
                <ngx-stripe-payment (ready)="loaded.emit(); loading.set(false);"/>
            </ngx-stripe-elements>
            @if(!manual()){
                <button mat-flat-button class="mt-10 submit-button premium-horizontal" type="button" (click)="submitIntent()" [disabled]="loading()">
                    @if(!loading()){
                        <h3 class="m-0">{{target() ? 'PAY NOW' : 'ADD CARD'}}</h3>
                    } @else {
                        <mat-icon class="rotating mx-0i sized" style="--icon-size: 26px;">autorenew</mat-icon>
                    }
                </button>
            }
        }
    }
    @case ('list'){
        <ng-container *ngTemplateOutlet="cardList"></ng-container>
    }
    @case ('selected'){
        <ng-container *ngTemplateOutlet="selected_method_id() ? previewCardSelected : previewNoCardSelected"></ng-container>
    }
}

<ng-template #cardList>
    <div class="card-list px-8">
        @for(payment_method of payment_methods(); track payment_method.intent_id){
            <div class="card-preview card-in-list">
                <ng-container *ngTemplateOutlet="cardInfo; context: { $implicit: payment_method }">
                </ng-container>
                <div class="card-actions">
                     @if(!loading()){
                         <button mat-icon-button paint="primary" class="mat-elevation-z0" type="button" (click)="selectCard(payment_method.intent_id)"><mat-icon>radio_button_{{selected_method_id() == payment_method.intent_id ? '' : 'un'}}checked</mat-icon></button>
                         <button mat-icon-button paint="warn" class="mat-elevation-z0" type="button" (click)="deleteCard(payment_method.intent_id)"><mat-icon>delete</mat-icon></button>
                     } @else {
                        <button mat-icon-button paint="dark" class="mat-elevation-z0" [disabled]="true" type="button"><mat-icon class="rotating">autorenew</mat-icon></button>
                     }
                </div>
            </div>
        }
    </div>
    <ng-container *ngTemplateOutlet="previewNoCardSelected"></ng-container>
</ng-template>

<ng-template #previewCardSelected>
    <div class="card-preview">
        <ng-container *ngTemplateOutlet="cardInfo; context: { $implicit: selected_method() }">
        </ng-container>
        <div class="card-actions">
            <!-- <button mat-flat-button color="primary">Edit</button> -->
            <button mat-icon-button color="primary" class="mat-elevation-z0" type="button" (click)="selected_view.set('list')"><mat-icon>expand_circle_down</mat-icon></button>
        </div>
    </div>
</ng-template>

<ng-template #previewNoCardSelected>
    <div class="no-cards" [class.hidden]="loading()">
        <button mat-button paint="primary" class="card-new" type="button" (click)="loading.set(true); selected_view.set('add')">
            ADD NEW PAYMENT METHOD
        </button>
    </div>
</ng-template>

<ng-template #cardInfo let-payment_method>
    <div class="card-info">
        @if(cardTypes.includes(payment_method?.card?.brand)){
            <img class="card-brand-img" src="old/payments/{{payment_method.card.brand || 'unknown'}}.svg" [alt]="payment_method.card.brand || 'unknown payment method'"/>
        } @else {
            <img class="card-brand-img card-brand-default" src="old/payments/unknown.png" alt="unknown payment method"/>
        }
        <div>
            <div class="card-info-1">
                <h3 class="m-0 regular">
                    **** **** **** {{payment_method?.card?.last4 || '????'}}
                </h3>
            </div>
            @if(payment_method?.card?.exp_month && payment_method.card.exp_year){
                <div class="card-info-2">
                    <small class="m-0 regular">
                        <span>
                            Valid Until: {{('0'+payment_method.card.exp_month).slice(-2)}}/{{payment_method.card.exp_year}}
                        </span>
                        @if(!loading()){
                            @if(payment_method.card.exp_year < today[0] || (payment_method.card.exp_year == today[0] && payment_method.card.exp_month < today[1])){
                                <mat-icon class="sized interactive" matTooltip="Card has Expired. Click to update" style="--isize: 16px;" paint="warn" (click)="updateCard(payment_method.intent_id, payment_method.card)">warning</mat-icon>
                            } @else {
                                <mat-icon class="sized interactive" matTooltip="Update Expiry" style="--isize: 16px;" paint="accent" (click)="updateCard(payment_method.intent_id, payment_method?.card)">edit</mat-icon>
                            }
                        }
                    </small>
                </div>
            }
        </div>
    </div>
</ng-template>

<ng-template #updateForm let-terminate="terminate" let-submit="submit">
    <div class="p-10">
        <label>Expiry Date</label>
        <div class="floating-control">
            <input matInput [matDatepicker]="picker" [formControl]="expiry" [min]="minDate" (focus)="onFocus($event, picker)">
            <mat-datepicker-toggle class="f-cross-center" matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="multi-year" (monthSelected)="expiry.setValue($event); picker.close()"></mat-datepicker>
        </div>
        <div class="field-info">
            @if(expiry.touched && expiry.errors){
                <mat-error>
                    @if(expiry.hasError('required')){
                        Date is required
                    } @else if(expiry.hasError('matDatepickerParse')){
                        Date is invalid
                    } @else if(expiry.hasError('matDatepickerMin')){
                        Date is expired
                    }
                </mat-error>
            } @else {
                <mat-hint>&nbsp;</mat-hint>
            }
        </div>
    </div>
</ng-template>